module.exports = __webpack_public_path__ + "img/student-record-hover.9fde9a2e.svg";